<template>
  <navigation :currentPage="'index'" />
  <div class="home">
     <SelectedBlock v-if="info.count > 0" v-for="res in info.results" :res=res />
     <KuFooter/>
  </div>
</template>

<script>
// @ is an alias to /src
import navigation from '@/components/Navigation.vue'
import SelectedBlock from '@/components/SelectedBlock.vue';
import KuFooter from '@/components/KuFooter.vue';
import axios from 'axios';

export default {
  name: 'HomeView',
  components: {
    navigation,
    SelectedBlock,
    KuFooter,
  },

  data: function(){
    return{
      info:'',
    }
  },

  mounted(){
    this.getSelData()
  },

  methods:{
    getSelData: function(){
      axios
        .get('/api/sel')
        .then(response => {
          this.info = response.data;
        })
        .catch(error => {
            console.log(error)
        })
    }
  }
}
</script>

<style>

.home{
  margin: 0;
  padding: 0;
  padding-top: 48px;
}

</style>
